import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ICService } from 'src/app/Service/IC/IC.service';

@Component({selector:'app-ic-equipment-tab',templateUrl:'./ICEquipmentTab.component.html',styleUrls:['./ICEquipmentTab.component.css']})
export class ICEquipmentTabComponent implements OnChanges {
  @Input() equipmentId?: number;
  history: any[] = [];
  due: any[] = [];
  loading = false;
  constructor(private service: ICService, private router: Router, private alert: AlertifyService) {}
  ngOnChanges(changes: SimpleChanges): void { if (changes['equipmentId'] && this.equipmentId) this.load(); }
  load(): void {
    if (!this.equipmentId) return;
    this.loading = true;
    forkJoin({history: this.service.getEquipmentHistory(this.equipmentId), due: this.service.getDue(undefined, this.equipmentId)}).subscribe({
      next: result => { this.history = result.history || []; this.due = result.due || []; },
      error: () => { this.loading = false; this.alert.ErrorMessage('دریافت وضعیت کنترل میانی ناموفق بود'); },
      complete: () => this.loading = false
    });
  }
  status(): string {
    if (this.history[0]?.result === 'FAIL') return 'UNDER_REVIEW';
    if (this.due.some(x => x.status === 'OVERDUE')) return 'OVERDUE';
    if (this.due.some(x => x.status === 'DUE')) return 'DUE';
    if (this.due.some(x => x.status === 'DUE_SOON')) return 'DUE_SOON';
    return this.history.length ? 'VALID' : (this.due.length ? 'UPCOMING' : 'NOT_ASSIGNED');
  }
  nextDue(): string | null { const values = this.due.map(x => x.nextDue).filter(Boolean).sort(); return values.length ? values[0] : null; }
  openHistory(): void { if (this.equipmentId) this.router.navigate(['/ic/execution/history', this.equipmentId]); }
  openTrend(): void { const itemId = Number(this.history[0]?.itemId); if (this.equipmentId && itemId) this.router.navigate(['/ic/trend', this.equipmentId, itemId]); }
}
